var React = require('react');

function IndustryGreenLineInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"m3.25 115.5.5-115.5","stroke":"#00933e","strokeLinecap":"square","key":0}),React.createElement("circle",{"cx":"3","cy":"115","fill":"#5ef99a","r":"3","key":1})]));
}

IndustryGreenLineInline.defaultProps = {"height":"118","viewBox":"0 0 6 118","width":"6"};

module.exports = IndustryGreenLineInline;

IndustryGreenLineInline.default = IndustryGreenLineInline;
